// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Lic_con__AGoL1{
    display: flex;
    margin-top: 40px;
}

.Lic_left__Ie-Y0,
.Lic_right__ehWnf{
    flex: 1 1;
    display: flex;
    flex-direction: column;
}

.Lic_right__ehWnf{
    border: 2px solid rgb(184,184,184);
    display: flex;
    align-items: center;
    border-radius: 5px;
}

.Lic_right__ehWnf h1{
    margin-top: 20px;
    font-size: 20px;
    margin-bottom: 10px;
}

.Lic_right__ehWnf span{
    font-size: 50px;
    margin-bottom: 10px;
    color: rgb(71, 122, 246);
}

.Lic_top__LiCr5,
.Lic_bottom__97CCO{
  margin-bottom: 5px;
    border: 2px solid rgb(184,184,184);
    padding-top: 20px;
    margin-right: 20px;
    border-radius: 5px;
    /* height: 40vh; */
    height: 100%;
    @media (max-width:657px) {
      width: 100%;
      
    }
}

/* .bottom{
    margin-top: 10px;
} */

.Lic_box__KiSF7{
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 20px;
}

.Lic_box__KiSF7 h1{
    margin-left: 15px;
    font-size: 20px;
    margin-bottom: 10px;
}

.Lic_box__KiSF7 input[type="checkbox"] {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    border: 2px solid rgb(184,184,184);
    outline: none; /* Remove default focus outline */
   
  }
  
  .Lic_box__KiSF7 input[type="checkbox"]:checked {
    background: radial-gradient(#525be8 46%, rgba(255, 255, 255, 0.7) 29%);
  }
  
  .Lic_cards__EN1\\+7{
    margin-bottom: 20px;
  }


  .Lic_inp__ZWW30 input::placeholder {
    text-align: center;
  }
  
  .Lic_inp__ZWW30{
    text-align: center;
    display: flex;
    align-items: center;
    border: 1px solid #ccc;
    /* margin-bottom: 20px;
    padding-right: 1rem;
    padding-top: 1rem; */
    margin-bottom: 1rem;
    padding: 1rem;
    width: 100%;
    @media (max-width:1260px) {
      padding-left: 1rem;
      margin-right: 1rem;
      width: 100%;
      
    }
  }

  .Lic_mar__zCH-a{
    margin-bottom: 15px;
  }

  .Lic_button__bY19R{
    background-color: rgb(58,120,231);
  }


.Lic_check__efBdI{
  display: flex;
}














@media (max-width: 720px) {
  .Lic_con__AGoL1{
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .Lic_inp__ZWW30{
    padding: none;
    margin: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Lic.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;;IAEI,SAAO;IACP,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;;EAEE,kBAAkB;IAChB,kCAAkC;IAClC,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ;MACE,WAAW;;IAEb;AACJ;;AAEA;;GAEG;;AAEH;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,aAAa,EAAE,iCAAiC;;EAElD;;EAEA;IACE,sEAAsE;EACxE;;EAEA;IACE,mBAAmB;EACrB;;;EAGA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB;;wBAEoB;IACpB,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX;MACE,kBAAkB;MAClB,kBAAkB;MAClB,WAAW;;IAEb;EACF;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iCAAiC;EACnC;;;AAGF;EACE,aAAa;AACf;;;;;;;;;;;;;;;AAeA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,YAAY;EACd;AACF","sourcesContent":[".con{\n    display: flex;\n    margin-top: 40px;\n}\n\n.left,\n.right{\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n}\n\n.right{\n    border: 2px solid rgb(184,184,184);\n    display: flex;\n    align-items: center;\n    border-radius: 5px;\n}\n\n.right h1{\n    margin-top: 20px;\n    font-size: 20px;\n    margin-bottom: 10px;\n}\n\n.right span{\n    font-size: 50px;\n    margin-bottom: 10px;\n    color: rgb(71, 122, 246);\n}\n\n.top,\n.bottom{\n  margin-bottom: 5px;\n    border: 2px solid rgb(184,184,184);\n    padding-top: 20px;\n    margin-right: 20px;\n    border-radius: 5px;\n    /* height: 40vh; */\n    height: 100%;\n    @media (max-width:657px) {\n      width: 100%;\n      \n    }\n}\n\n/* .bottom{\n    margin-top: 10px;\n} */\n\n.box{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin: 20px;\n}\n\n.box h1{\n    margin-left: 15px;\n    font-size: 20px;\n    margin-bottom: 10px;\n}\n\n.box input[type=\"checkbox\"] {\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    border-radius: 50%;\n    width: 30px;\n    height: 30px;\n    border: 2px solid rgb(184,184,184);\n    outline: none; /* Remove default focus outline */\n   \n  }\n  \n  .box input[type=\"checkbox\"]:checked {\n    background: radial-gradient(#525be8 46%, rgba(255, 255, 255, 0.7) 29%);\n  }\n  \n  .cards{\n    margin-bottom: 20px;\n  }\n\n\n  .inp input::placeholder {\n    text-align: center;\n  }\n  \n  .inp{\n    text-align: center;\n    display: flex;\n    align-items: center;\n    border: 1px solid #ccc;\n    /* margin-bottom: 20px;\n    padding-right: 1rem;\n    padding-top: 1rem; */\n    margin-bottom: 1rem;\n    padding: 1rem;\n    width: 100%;\n    @media (max-width:1260px) {\n      padding-left: 1rem;\n      margin-right: 1rem;\n      width: 100%;\n      \n    }\n  }\n\n  .mar{\n    margin-bottom: 15px;\n  }\n\n  .button{\n    background-color: rgb(58,120,231);\n  }\n\n\n.check{\n  display: flex;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@media (max-width: 720px) {\n  .con{\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n  }\n  .inp{\n    padding: none;\n    margin: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"con": `Lic_con__AGoL1`,
	"left": `Lic_left__Ie-Y0`,
	"right": `Lic_right__ehWnf`,
	"top": `Lic_top__LiCr5`,
	"bottom": `Lic_bottom__97CCO`,
	"box": `Lic_box__KiSF7`,
	"cards": `Lic_cards__EN1+7`,
	"inp": `Lic_inp__ZWW30`,
	"mar": `Lic_mar__zCH-a`,
	"button": `Lic_button__bY19R`,
	"check": `Lic_check__efBdI`
};
export default ___CSS_LOADER_EXPORT___;
